import TableEmptyScreen from "./TableEmptyScreen";

export default TableEmptyScreen;
